import Box from "@mui/material/Box";
import useIsCreate from "hooks/useIsCreate";
import { useParams, useSearchParams } from "react-router-dom";
import {
  OrderType,
  PlatformTrialListOrderFields,
  useExaminationHeaderQuery,
  useTrialListQuery,
} from "@generated/graphql";
import CircularLoading from "components/CircularLoading";
import { useMemo } from "react";
import qs from "qs";
import TrialList from "pages/Testing/view/Group/components/TrialList";
import ExaminationContent from "./components/Content";
import Header from "./components/Header";
import { ExaminationType } from "./types";

type SearchParams = {
  type: ExaminationType;
};

const ExaminationView = () => {
  const isCreate = useIsCreate();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const params = useMemo(() => {
    return qs.parse(searchParams.toString()) as SearchParams;
  }, [searchParams]);
  const searchExaminationType = params.type;

  const {
    data,
    loading,
    refetch: examinationHeaderRefetch,
  } = useExaminationHeaderQuery({
    variables: {
      examinationId: id!,
    },
    skip: !id,
  });

  const examinationType = (isCreate ? searchExaminationType : data?.examination.type) as
    | SearchParams["type"]
    | undefined;

  const trialsListPermanentFilter = {
    examinationId: id!,
  };

  const trialsListDefaultOrder = {
    field: PlatformTrialListOrderFields.CreatedAt,
    order: OrderType.Desc,
  };

  const {
    data: trialsListData,
    loading: trialsListLoading,
    refetch: trialsListRefetch,
  } = useTrialListQuery({
    variables: {
      page: 0,
      limit: 50,
      filter: trialsListPermanentFilter,
      order: trialsListDefaultOrder,
    },
    skip: !id,
  });

  const trials = trialsListData?.trials;

  if (loading) return <CircularLoading />;

  return (
    <Box>
      <Header
        trialsData={trials}
        examination={data?.examination}
        examinationType={examinationType}
        trialsListRefetch={trialsListRefetch}
        examinationHeaderRefetch={examinationHeaderRefetch}
      />
      <ExaminationContent examinationType={examinationType} />
      {!isCreate && (
        <TrialList
          trialsData={trials}
          loading={trialsListLoading}
          permanentFilter={trialsListPermanentFilter}
          defaultOrder={trialsListDefaultOrder}
          refetch={trialsListRefetch}
        />
      )}
    </Box>
  );
};
export default ExaminationView;
